export function getCentroCostoId(source) {
  const raw = source?.centro_costo?.id ?? source?.centro_costo ?? '';
  return raw !== undefined && raw !== null && raw !== '' ? String(raw) : '';
}

export function getCentroCostoPreferidoDesdeEquipo(equipo) {
  const desdeObra = equipo?.obra?.centro_costo?.id
    ?? equipo?.obra?.centro_costo
    ?? equipo?.obra_centro_costo
    ?? '';
  if (desdeObra !== undefined && desdeObra !== null && desdeObra !== '') {
    return String(desdeObra);
  }
  return getCentroCostoId(equipo);
}

export function getObraId(source) {
  const raw = source?.obra?.id ?? source?.obra ?? '';
  return raw !== undefined && raw !== null && raw !== '' ? String(raw) : '';
}

export async function fetchCentroCostoId(apiClient, endpoint, id) {
  if (!id) return '';
  const base = endpoint.endsWith('/') ? endpoint : `${endpoint}/`;
  const response = await apiClient.get(`${base}${id}/`);
  return getCentroCostoId(response.data || {});
}

export async function fetchCentroCostoPreferidoDesdeEquipo(apiClient, equipoId) {
  if (!equipoId) return '';
  const response = await apiClient.get(`equipos/${equipoId}/`);
  return getCentroCostoPreferidoDesdeEquipo(response.data || {});
}

export function getUbicacionId(source) {
  const raw = source?.ubicacion?.id ?? source?.ubicacion ?? '';
  return raw !== undefined && raw !== null && raw !== '' ? String(raw) : '';
}

export function getUbicacionDesdeObra(obra) {
  const desdeObra = obra?.ubicacion?.id ?? obra?.ubicacion ?? '';
  if (desdeObra !== undefined && desdeObra !== null && desdeObra !== '') {
    return String(desdeObra);
  }
  return '';
}

export async function fetchObraDetails(apiClient, obraId) {
  if (!obraId) return null;
  try {
    const response = await apiClient.get(`obras/${obraId}/`);
    return response.data || null;
  } catch (err) {
    console.warn(`Error fetching obra ${obraId}:`, err);
    return null;
  }
}